<template>
  <BaseConfirmation
    description="The amount entered is less than the
      transaction amount due. Are you sure
      you would like to confirm this transaction."
    :is-showing="isRevealed"
  >
    <template #actions>
      <BaseConfirmationButton
        variant="negative"
        @click="confirm({ payRestWithCard: false })"
      >
        Confirm transaction
      </BaseConfirmationButton>
      <BaseConfirmationButton
        variant="negative"
        @click="confirm({ payRestWithCard: true })"
      >
        Pay rest with card
      </BaseConfirmationButton>
      <BaseConfirmationButton
        variant="cancel"
        @click="cancel"
      >
        Go back
      </BaseConfirmationButton>
    </template>
  </BaseConfirmation>
</template>

<script setup lang="ts">
import { useConfirmDialog } from "@vueuse/core"

const { reveal, isRevealed, confirm, cancel } =
  useConfirmDialog<unknown, { payRestWithCard: boolean }>()

defineExpose({
  reveal,
})
</script>
